import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/xmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-652e6417"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "exhibitor-detail-dialog"
}
const _hoisted_2 = {
  class: "exhibitor-detail-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "exhibitor-detail-container" }
const _hoisted_7 = { class: "left-infos" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = {
  key: 0,
  class: "address"
}
const _hoisted_10 = {
  key: 1,
  class: "plz"
}
const _hoisted_11 = {
  key: 2,
  class: "country"
}
const _hoisted_12 = {
  key: 3,
  class: "phone"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }, null, -1))
const _hoisted_14 = {
  key: 4,
  class: "web"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe" }, null, -1))
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 5,
  class: "email"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 6,
  class: "socials"
}
const _hoisted_21 = { class: "social" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 7,
  class: "stand-container"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1))
const _hoisted_25 = { class: "stands" }
const _hoisted_26 = ["onClick", "innerHTML"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "exhibitor-infos" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "footer" }
const _hoisted_32 = { class: "products-header" }
const _hoisted_33 = { class: "product" }
const _hoisted_34 = { class: "product-stand-container" }
const _hoisted_35 = { class: "product-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theme_root = _resolveComponent("theme-root")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.exhibitor.name), 1),
              (_ctx.exhibitor.address)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.exhibitor.address), 1))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.plz || _ctx.exhibitor.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.exhibitor.plzAndCity), 1))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.country)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.exhibitor.country), 1))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.phone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.exhibitor.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.web)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(),
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.exhibitor.webWithProtocol
                    }, _toDisplayString(_ctx.exhibitor.web), 9, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(),
                    _createElementVNode("a", {
                      target: "_blank",
                      href: 'mailto:'+ _ctx.exhibitor.email
                    }, _toDisplayString(_ctx.exhibitor.email), 9, _hoisted_19)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.socials)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitor.socials, (social) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa-brands", _ctx.getIconBySocialType(social.type)])
                        }, null, 2),
                        _createTextVNode(),
                        _createElementVNode("a", {
                          target: "_blank",
                          href: social.urlWithProtocol
                        }, _toDisplayString(social.url), 9, _hoisted_22)
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.exhibitor.stands)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitor.stands, (stand, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stand",
                          onClick: ($event: any) => (_ctx.callOpenStandDialog(stand,$event)),
                          innerHTML: (stand.getDisplayName() + (index !== _ctx.exhibitor.stands.length -1 ? ',' : ''))
                        }, null, 8, _hoisted_26))
                      }), 256))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.exhibitor.logo ? 'exhibitor-logo' : 'exhibitor-logo-letter')
            }, [
              (_ctx.exhibitor.logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.exhibitor.getLogoUrl()
                  }, null, 8, _hoisted_27))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.exhibitor.getFirstLetter()), 1))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.exhibitor.info)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "infos",
                  innerHTML: _ctx.exhibitor.info
                }, null, 8, _hoisted_30))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            (_ctx.exhibitor.themesDisplay)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.themeTrees, (three) => {
                  return (_openBlock(), _createBlock(_component_theme_root, {
                    root: three.root,
                    themes: _ctx.themes,
                    "entity-themes": _ctx.exhibitor.themesDisplay
                  }, null, 8, ["root", "themes", "entity-themes"]))
                }), 256))
              : _createCommentVNode("", true),
            (_ctx.exhibitor.products)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('products')), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitor.products, (product) => {
                      return (_openBlock(), _createElementBlock("li", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(product.name), 1)
                        ])
                      ]))
                    }), 256))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}